let shippingEstimatorOpener;
    try { shippingEstimatorOpener = document.querySelector('.shipping-bg-light-grey'); }
    catch(e) { console.error(e)}
if (shippingEstimatorOpener) {
    try { shippingEstimatorOpener.setAttribute("open", ""); }
    catch(e) { console.error(e)}

let shippingEstimatorHider = shippingEstimatorOpener.querySelector('summary');
    try { shippingEstimatorHider.style.display = "none"; }
    catch(e) { console.error(e)}

let shippingEstimatorAutocomplete = shippingEstimatorOpener.querySelector('#address_zip');
    try { shippingEstimatorAutocomplete.setAttribute("autocomplete", "off"); }
    catch(e) { console.error(e)}
}